<template>
    <div>
        <div class="content-caption dashed">
            <span>套装信息</span>
            <div class="input-tip error">提示:一次调拨数据最多500条</div>
            <span>
                <button v-if="!taxRateChange" class="swb-btn swb-btn-small" @click="showDeviceListDlg()">套装选择</button>
            </span>
        </div>
        <div class="table-layout">
            <div class="input-tip error" v-if="!crossComFlag">提示:内部调拨时,套装中资产如果在目标仓库，不会进行调拨并不展示出来。</div>
            <div class="right-toolbar mb5 fr">
                <span v-if="itemList != null">已选择({{itemList.length}})</span>
            </div>
            <div v-if="!isUpdate">
                <el-table :data="itemList" border>
                    <el-table-column prop="no" label="套装系统编号" width="180" align="center"></el-table-column>
                    <el-table-column prop="name" label="套装名称" align="left" width="150" show-overflow-tooltip></el-table-column>
                    <el-table-column label="套内资产数量" width="100" align="right" show-overflow-tooltip>
                        <template slot-scope="rows">
                            <span v-if="rows.row.shopDeviceSuitAccList != null">{{rows.row.shopDeviceSuitAccList.length + 1}}</span>
                            <span v-else>1</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="调入信息" width="300">
                        <template slot-scope="scope">
                            <span v-if="scope.row.dstMerchantId != scope.row.retailerId && scope.row.dstMerchantName != null">{{scope.row.dstMerchantName}}</span>
                            <span v-if="scope.row.dstMerchantId != scope.row.retailerId && scope.row.dstMerchantName != null && scope.row.dstBizUnitName != null">/</span>
                            <span v-if="scope.row.dstBizUnitName != null">{{scope.row.dstBizUnitName}}</span>
                            <span v-if="scope.row.dstBizUnitName != null && scope.row.dstComName != null && scope.row.dstBizUnitName != scope.row.dstComName">/{{scope.row.dstComName}}</span>
                            <a v-if="!taxRateChange" class="swb-btn-link" align="right" @click="selectDstBizUnitName(scope.$index)">选择机构</a>
                        </template>
                    </el-table-column>
                    <!--<el-table-column prop="dstMerchantName" label="调入商户" width="140">-->
                        <!--<template slot-scope="scope">-->
                            <!--<span align="left" v-if="scope.row.dstMerchantName != null">{{scope.row.dstMerchantName}}</span>-->
                            <!--<a v-if="!taxRateChange" class="swb-btn-link" align="right" @click="selectDstMerchtName(scope.$index)">调入商户</a>-->
                        <!--</template>-->
                    <!--</el-table-column>-->
                    <!--<el-table-column prop="dstBizUnitName" label="调入业务单元" width="140"></el-table-column>-->
                    <!--<el-table-column prop="dstComName" label="调入部门" width="140">-->
                        <!--<template slot-scope="scope">-->
                            <!--<span align="left" v-if="scope.row.dstComName != null">{{scope.row.dstComName}}</span>-->
                            <!--<a v-if="!taxRateChange" class="swb-btn-link" align="right" @click="selectDstBizUnitName(scope.$index)">选择部门</a>-->
                        <!--</template>-->
                    <!--</el-table-column>-->
                    <el-table-column prop="dstWarehouseName" label="调入仓库" width="140" align="center">
                        <template slot-scope="scope">
                            <el-select :disabled="taxRateChange" v-model="scope.row.dstWarehouseId" placeholder="请选择" @change="selectDstWarehouse(scope.$index)">
                                <el-option v-for="item in scope.row.dstWareHouseList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column prop="taxRate" label="税率(%)" width="140" v-if="normalFlag">
                        <template slot-scope="scope">
                            <span v-if="!taxRateChange">{{scope.row.taxRate}}</span>
                            <el-select v-else-if="taxRateChange" v-model="scope.row.taxRate" placeholder="请选择税率">
                                <el-option v-for="item in fiscalTaxMarkList" :key="item.rate" :label="item.rate" :value="item.rate"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column prop="devcTitle" label="主资产名称" align="left" width="150" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="devcTmpNo" label="主资产系统编号" width="250" align="left" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="devcCatName" label="主资产分类" width="150" align="left" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="devcBrandName" label="主资产品牌" width="150" align="left" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="devcModelSpec" label="主资产规格" width="150" align="left" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="departName" label="主资产责任部门" width="150" align="left" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="principalName" label="主资产责任人" width="150" align="left" show-overflow-tooltip></el-table-column>
                    <el-table-column align="center" width="80" label="操作" show-overflow-tooltip fixed="right">
                        <template slot-scope="scope">
                            <a v-if="!taxRateChange" class="swb-btn-link" @click="removeItem(scope.$index)">移除</a>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-else><!-- 更新展示方式 -->
                <el-table :data="curDeviceItemList" border>
                    <el-table-column prop="title" label="设备名称" align="left" width="150" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="tmpNo" label="系统编号" align="center"></el-table-column>
                    <el-table-column label="是否主资产" align="center" width="100">
                        <template slot-scope="rows">
                            <span v-if="rows.row.suitMainFlag" class="font-green">是</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="调入信息" width="300">
                        <template slot-scope="scope">
                            <span v-if="scope.row.dstMerchantId != scope.row.retailerId && scope.row.dstMerchantName != null">{{scope.row.dstMerchantName}}</span>
                            <span v-if="scope.row.dstMerchantId != scope.row.retailerId && scope.row.dstMerchantName != null && scope.row.dstBizUnitName != null">/</span>
                            <span v-if="scope.row.dstBizUnitName != null">{{scope.row.dstBizUnitName}}</span>
                            <span v-if="scope.row.dstBizUnitName != null && scope.row.dstComName != null && scope.row.dstBizUnitName != scope.row.dstComName">/{{scope.row.dstComName}}</span>
                            <a v-if="!taxRateChange" class="swb-btn-link" align="right" @click="selectDstBizUnitName(scope.$index)">选择机构</a>
                        </template>
                    </el-table-column>
                    <!--<el-table-column prop="dstMerchantName" label="调入商户" width="140">-->
                        <!--<template slot-scope="scope">-->
                            <!--<span align="left" v-if="scope.row.dstMerchantName != null">{{scope.row.dstMerchantName}}</span>-->
                            <!--<a v-if="!taxRateChange" class="swb-btn-link" align="right" @click="selectDstMerchtName(scope.$index)">调入商户</a>-->
                        <!--</template>-->
                    <!--</el-table-column>-->
                    <!--<el-table-column prop="dstBizUnitName" label="调入业务单元" width="140"></el-table-column>-->
                    <!--<el-table-column prop="dstComName" label="调入部门" width="140">-->
                        <!--<template slot-scope="scope">-->
                            <!--<span align="left" v-if="scope.row.dstComName != null">{{scope.row.dstComName}}</span>-->
                            <!--<a v-if="!taxRateChange" class="swb-btn-link" align="right" @click="selectDstBizUnitName(scope.$index)">选择部门</a>-->
                        <!--</template>-->
                    <!--</el-table-column>-->
                    <el-table-column prop="dstWarehouseName" label="调入仓库" width="140" align="center">
                        <template slot-scope="scope">
                            <el-select :disabled="taxRateChange" v-model="scope.row.dstWarehouseId" placeholder="请选择" @change="selectDstWarehouse(scope.$index)">
                                <el-option v-for="item in scope.row.dstWareHouseList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column prop="taxRate" label="税率(%)" width="140" v-if="normalFlag">
                        <template slot-scope="scope">
                            <span v-if="!taxRateChange">{{scope.row.taxRate}}</span>
                            <el-select v-else-if="taxRateChange" v-model="scope.row.taxRate" placeholder="请选择税率">
                                <el-option v-for="item in fiscalTaxMarkList" :key="item.rate" :label="item.rate" :value="item.rate"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column prop="suitNo" label="套装编号" align="center" width="200"></el-table-column>
                    <el-table-column prop="catName" label="设备分类" width="150" align="left" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="brandName" label="设备品牌" width="150" align="left" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="modelSpec" label="设备规格" width="150" align="left" show-overflow-tooltip></el-table-column>
                    <el-table-column v-if="!confirm" align="center" width="80" label="操作" show-overflow-tooltip fixed="right">
                        <template slot-scope="scope">
                            <a v-if="!taxRateChange" class="swb-btn-link" @click="removeDeviceItem(scope.$index)">移除</a>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues';

    import { openShopDeviceSuitSelectDlg } from './selectDlg';
    import { getMerchantBizParam } from '../asset/assetMain'
    import { openComStaffComnSelectDlg, openComStaffMainForSelectDlg, openBizDepartDlg } from '../orgStruct/selectDlg';
    import { showAssetSelectDlg, showLowCostSelectDlg, openRetailComTreeSelectDlg, openRetailerListForSelectDlg } from '../retailer/selectDlg';

    import userApi from '../../api/user';
    import shopDevcApi from '../../api/shopDevc';
    import shopStockApi from '../../api/shopStock'
    import assetVchrApi from '../../api/assetVchr'
    import fiscalBizApi from '../../api/fiscalBiz'

    export default {
        name: 'swb-shop-device-suit-stock-trans-item-select',
        props: {
            suitFlag: {
                type: Boolean,
                default: false,
            },
            deviceItemList: {
                type: Array,
                default: null,
            },
            confirm: {
                type: Boolean,
                default: false,
            },
            srcBizUnitId: {
                type: Number,
                default: null,
            },
            dstBizUnitId: {
                type: Number,
                default: null,
            },
            taxRateChange: {
                type: Boolean,
                default: false,
            }
        },

        data: function () {
            return {
                itemList: [],
                curDeviceItemList: [],
                dstWarehouseName: null,
                dstWarehouseId: null,
                isUpdate: false,
                wareHouseInList: [],
                sameWarehouseFlag: false,
                scopeEntity: {},
                fiscalTaxMarkList: [],
                normalFlag: false,
                defaultTaxRate: 0
            }
        },
        watch: {
            suitFlag(oldVal, newVal){
                if(oldVal != newVal) {
                    this.itemList = [];
                }
            },
            srcBizUnitId(oldVal, newVal){
                if(oldVal != newVal) {
                    this.itemList = [];
                }
            }
        },
        created: function () {
            let self = this;
            getMerchantBizParam("asset.finac.enabled", function (result) {
                self.normalFlag = Utils.isTrue(result);
            }, 2, self.srcBizUnitId);
            getMerchantBizParam("trans.between.same.warehouse.allowed", function (result) {
                self.sameWarehouseFlag = Utils.isTrue(result);
            });
            getMerchantBizParam("asset.trans.biz.default.tax.rate", function (result) {
                self.defaultTaxRate = result;
            });
            let deviceItemList = this.deviceItemList;
            if(!Utils.isNoB(deviceItemList) && deviceItemList.length > 0) {
                this.isUpdate = true;
                this.curDeviceItemList = deviceItemList;
            }
            this.getFiscalTaxMarkList();
            this.getCurrentUserInfo();
        },
        methods: {
            getFiscalTaxMarkList: function () {
                let self = this;
                let postData = {};
                postData.disabled = false;
                postData.type = getEnumInfoWith('taxType', "name", "XXS").value;
                //
                let theLoad = MsgBox.loading();
                fiscalBizApi.getFiscalTaxMarkPageList(postData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        let fiscalTaxMarkList = result.data || [];
                        if(fiscalTaxMarkList.length > 0) {
                            fiscalTaxMarkList.forEach(function (item) {
                                item.rate = parseFloat(item.rate).toFixed(2)
                            })
                        }
                        self.fiscalTaxMarkList = fiscalTaxMarkList;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getCurrentUserInfo: function () {
                let self = this;
                userApi.getUserInfoByContext({}, function (result, jqXhr) {
                    if(result.type == 'info') {
                        let data = result.data;
                        self.scopeEntity = data.scopeEntity || {};
                    } else {
                        self.$message.error(result.message);
                    }
                });
            },
            // 选择套装
            showDeviceListDlg: function () {
                let self = this;
                let isUpdate = this.isUpdate;
                //
                let params = {};
                params.thisComId = this.srcBizUnitId;
                params.relFlag = true;
                params.includeItems = true;
                params.locked = false;
                openShopDeviceSuitSelectDlg(params, function (suitList) {
                    if(isUpdate) {
                        // --- 按照单项展示
                        self.makeDeviceItemList(suitList);
                    } else {
                        // 按照套装展示
                        suitList.forEach(function (item) {
                            item.srcComId = item.retailerShopId;
                            item.srcComName = item.retailerShopName;
                            //
                            item.dstMerchantId = self.scopeEntity.id;
                            item.dstMerchantName = self.scopeEntity.name;
                            item.taxRate = self.defaultTaxRate;
                        });
                        self.itemList = Utils.merge([], suitList);
                    }
                });
            },
            // 修改- 处理单项显示
            makeDeviceItemList: function (suitList) {
                let self = this;
                let curDeviceItemList = this.curDeviceItemList || [];
                //
                suitList.forEach(function (suit) {
                    let device = suit.shopDeviceSvcSubNo;   // 主资产
                    let suitNo = suit.no;
                    //
                    let suitAccList = [];
                    let suitMain = {    // 主资产
                        shopDeviceSvcSubNo: device
                    };
                    suitAccList.push(suitMain);
                    //
                    let shopDeviceSuitAccList = Utils.merge([], suit.shopDeviceSuitAccList);     // 附属设备
                    suitAccList.add(shopDeviceSuitAccList);
                    //
                    if(suitAccList != null && suitAccList.length > 0) {
                        let length = suitAccList.length;
                        for(let i = 0; i < length; i++) {
                            let item = suitAccList[i].shopDeviceSvcSubNo;
                            let transItem = self.makeTransItemInfo(item, suitNo);
                            if(!Utils.isNoB(transItem)) {
                                curDeviceItemList.push(transItem);
                            }
                        }
                    }
                });
                this.curDeviceItemList = Utils.merge([], curDeviceItemList);
            },
            // 移除套装
            removeItem: function (index) {
                let self = this;
                let itemList = self.itemList;
                itemList.splice(index, 1);
                //
                self.itemList = Utils.merge([], itemList);
            },
            // 修改时 - 移除单个单项
            removeDeviceItem: function (index) {
                let curDeviceItemList = this.curDeviceItemList;
                curDeviceItemList.splice(index, 1);
                //
                this.curDeviceItemList = Utils.merge([], curDeviceItemList);
            },
            // 组合调拨-设备的数据
            makeTransItemInfo: function (deviceSvc, suitNo) {
                let transItem = {};
                // 设备信息
                transItem.durable = false;
                transItem.title = deviceSvc.title;
                transItem.deviceXId = deviceSvc.id;
                transItem.batchNo = deviceSvc.batchNo;
                transItem.rented = deviceSvc.rented;
                transItem.tmpNo = deviceSvc.tmpNo;
                transItem.catId = deviceSvc.catId;
                transItem.catName = deviceSvc.catName;
                transItem.brandId = deviceSvc.brandId;
                transItem.brandName = deviceSvc.brandName;
                transItem.innerDevcCatId = deviceSvc.innerDevcCatId;
                transItem.innerDevcCatName = deviceSvc.innerDevcCatName;
                transItem.acctEnterWay = deviceSvc.acctEnterWay;
                transItem.orgWorth = deviceSvc.orgWorth;
                transItem.netWorth = deviceSvc.netWorth;
                transItem.theUnit = deviceSvc.theUnit;
                transItem.deviceFiscalAccFlag = deviceSvc.fiscalAcctFlag;
                transItem.srcComId = deviceSvc.retailerShopId;
                transItem.srcComName = deviceSvc.retailerShopName;
                transItem.dstMerchantId = deviceSvc.dstMerchantId;
                transItem.dstMerchantName = deviceSvc.dstMerchantName;
                transItem.dstBizUnitId = deviceSvc.dstBizUnitId;
                transItem.dstBizUnitName = deviceSvc.dstBizUnitName;
                transItem.dstComId = deviceSvc.dstComId;
                transItem.dstComName = deviceSvc.dstComName;
                transItem.dstWarehouseId = deviceSvc.dstWarehouseId;
                transItem.dstWarehouseName = deviceSvc.dstWarehouseName;
                transItem.taxRate = deviceSvc.taxRate;
                // 套装信息
                transItem.suitNo = suitNo;
                transItem.suitMainFlag = deviceSvc.suitMainFlag;
                //
                return transItem;
            },
            getResult: function () {
                let self = this;
                let result = {};
                result.type = 'info';
                // ---------
                let transItemList = [];
                if(this.isUpdate) {
                    // --- 更新返回的数据
                    transItemList = this.curDeviceItemList || [];
                } else {
                    // 保存返回的数据
                    let suitList = self.itemList || [];
                    //
                    suitList.forEach(function (suit) {
                        let device = suit.shopDeviceSvcSubNo;   // 主资产
                        let suitNo = suit.no;
                        //
                        let shopDeviceSuitAccList = Utils.merge([], suit.shopDeviceSuitAccList);     // 附属设备
                        let suitMain = {    // 主资产
                            shopDeviceSvcSubNo: device
                        };
                        shopDeviceSuitAccList.push(suitMain);
                        //
                        if(shopDeviceSuitAccList != null && shopDeviceSuitAccList.length > 0) {
                            let length = shopDeviceSuitAccList.length;
                            for(let i = 0; i < length; i++) {
                                let item = shopDeviceSuitAccList[i].shopDeviceSvcSubNo;
                                item.dstMerchantId = suit.dstMerchantId;
                                item.dstMerchantName = suit.dstMerchantName;
                                item.dstBizUnitId = suit.dstBizUnitId;
                                item.dstBizUnitName = suit.dstBizUnitName;
                                item.dstComId = suit.dstComId;
                                item.dstComName = suit.dstComName;
                                item.dstWarehouseId = suit.dstWarehouseId;
                                item.dstWarehouseName = suit.dstWarehouseName;
                                item.taxRate = suit.taxRate;
                                //
                                let transItem = self.makeTransItemInfo(item, suitNo);
                                if(!Utils.isNoB(transItem)) {
                                    transItemList.push(transItem);
                                }
                            }
                        }
                    });
                }
                //
                if(transItemList == null || transItemList.length <= 0) {
                    result.type = 'warn';
                    result.message = "请选择资产信息！";
                    result.data = [];
                } else {
                    result.data = transItemList;
                }
                return result;
            },
            getAllotAcntType: function (item, callBack) {
                let theLoad = MsgBox.loading();
                let postData = {
                    dstComId: item.dstComId,
                    srcComId: item.srcComId
                };
                assetVchrApi.getShopDeviceTransVoucherAllotAcntType(postData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        //
                        callBack(result.data)
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            selectDstMerchtName(index){
                let self = this;
                let singleDeviceList = self.itemList || [];
                let deviceInfo = singleDeviceList[index];
                //
                let params = {
                    isMultiple: false,
                    selectCheckComInfo: {
                        id: deviceInfo.dstMerchantId,
                        name: deviceInfo.dstMerchantName
                    }
                };
                openRetailerListForSelectDlg(params, function (resultData) {
                    deviceInfo.dstMerchantId = resultData.id;
                    deviceInfo.dstMerchantName = resultData.name;
                    deviceInfo.dstBizUnitId = null;
                    deviceInfo.dstBizUnitName = null;
                    deviceInfo.dstComId = null;
                    deviceInfo.dstComName = null;
                    deviceInfo.dstWarehouseId = null;
                    deviceInfo.dstWarehouseName = null;
                    deviceInfo.dstWareHouseList = [];
                    //
                    self.itemList = Utils.merge([], singleDeviceList);
                });
            },
            //
            selectDstBizUnitName(rowIndex){
                let self = this;
                let deviceItemList = self.itemList;
                let deviceInfo = deviceItemList[rowIndex];
                //
                let dlgConfig = {
                    merchantId: deviceInfo.dstMerchantId,
                    isRadio: true,
                    isCom: true,
                    enableSearch: true,
                    bizDepart: true,
                    title: '机构--选择',
                    showMerchtSelect: true
                };
                openRetailComTreeSelectDlg(dlgConfig, function (result) {
                    deviceInfo.dstMerchantId = result.merchantId;
                    deviceInfo.dstMerchantName = result.merchantName;
                    deviceInfo.dstBizUnitId = result.bizUnitId;
                    deviceInfo.dstBizUnitName = result.bizUnitName;
                    deviceInfo.dstComId = result.id;
                    deviceInfo.dstComName = result.name;
                    //
                    self.getAllotAcntType(deviceInfo, function (allotAcntType) {
                        deviceInfo.allotAcntType = allotAcntType;
                        self.getDstWarehouseList(result.bizUnitId, function (dstWareHouseList) {
                            //
                            deviceInfo.dstWareHouseList = Utils.merge([], dstWareHouseList);
                            let defWare = dstWareHouseList.find(function (ware) {
                                return ware.defaulted == true;
                            });
                            deviceInfo.dstWarehouseId = defWare.id;
                            deviceInfo.dstWarehouseName = defWare.name;
                            self.itemList = Utils.merge([], deviceItemList);
                        });
                    });
                });
            },
            getDstWarehouseList: function (retailerShopId, callbackFun) {
                let filterItems = {};
                filterItems.retailerShopId = retailerShopId;
                let postData = {
                    filterItems: filterItems
                };
                let theLoad = MsgBox.loading();
                shopStockApi.getShopWarehouseNotPageList(postData, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        //
                        callbackFun(result.data);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            selectDstWarehouse(rowIndex){
                let self = this;
                let deviceItemList = self.itemList;
                let deviceInfo = deviceItemList[rowIndex];
                let dstWarehouseId = deviceInfo.dstWarehouseId;
                let dstWareHouseList = deviceInfo.dstWareHouseList;
                let wareHouse = dstWareHouseList.find(function (item) {
                    return item.id == dstWarehouseId;
                });
                deviceInfo.dstWarehouseName = wareHouse.name;
                self.itemList = Utils.merge([], deviceItemList);
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/retailer/ShopDeviceSuitStockTransItemSelect.vue